import React from 'react';

const ManageInvestorsIcon = ({ colour = '#2F8FFF', height = '20', width = '20' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" color={colour} xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_6496_211798" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
                <rect width="20" height="20" fill="#D9D9D9" />
            </mask>

            <g mask="url(#mask0_6496_211798)">
                <path
                    d="M1.66602 17.5V2.5H9.99935V5.83333H18.3327V17.5H1.66602ZM3.33268 15.8333H8.33268V14.1667H3.33268V15.8333ZM3.33268 12.5H8.33268V10.8333H3.33268V12.5ZM3.33268 9.16667H8.33268V7.5H3.33268V9.16667ZM3.33268 5.83333H8.33268V4.16667H3.33268V5.83333ZM9.99935 15.8333H16.666V7.5H9.99935V15.8333ZM11.666 10.8333V9.16667H14.9993V10.8333H11.666ZM11.666 14.1667V12.5H14.9993V14.1667H11.666Z"
                    fill={colour}
                />
            </g>
        </svg>
    );
};

export default ManageInvestorsIcon;
